
















































import {
  useFetch, defineComponent, ref, useRoute, nextTick, useMeta, computed, useContext, toRef,
} from '@nuxtjs/composition-api';
import useStoryblokView from '~/modules/storyblok/composables/useStoryblokView';
import { Pagination, useUiHelpers } from '~/composables';
import CategoryPagination from '~/modules/catalog/category/components/pagination/CategoryPagination.vue';
import BlogNewsArticleTile from '~/modules/storyblok/components/Blog/BlogNewsArticleTile.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import {
  getMetaInfo, getPaginationMeta, getStoryMeta, getUrlMeta,
} from '~/helpers/getMetaInfo';

export default defineComponent({
  components: { SkeletonLoader, BlogNewsArticleTile, CategoryPagination },

  props: {
    blok: {
      type: Object,
      required: true,
    },
    currentStory: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const route = useRoute();
    const currentStory = toRef(props, 'currentStory');
    const { getArticles } = useStoryblokView();
    const uiHelpers = useUiHelpers();
    const { app } = useContext();
    const lang = computed(() => app.i18n.locale);

    const articles = ref([]);
    const { search } = route.value.query;
    const postsContainerElement = ref<HTMLElement | null>(null);
    const pagination = ref<Pagination>({
      currentPage: 0,
      totalPages: 0,
    });
    const PER_PAGE = 8;
    const getTotalPages = (headers) => Math.ceil(Number(headers.total) / Number(headers['per-page']));
    const loading = ref(true);
    const queryPage = () => Number(uiHelpers.resolveQuery()?.page ?? 1);
    const currentPage = () => (pagination.value.totalPages !== 0
    && queryPage() > pagination.value.totalPages
      ? 1
      : queryPage());

    const metaInfo = () => {
      const urlMeta = getUrlMeta(uiHelpers.resolvePath());
      const paginationMeta = getPaginationMeta({
        pagination: pagination.value,
        route: queryPage(),
        baseData: urlMeta,
      });

      return getStoryMeta({
        data: { ...currentStory.value, slug: 'blog' },
        baseData: paginationMeta,
        lang: lang.value,
      });
    };
    useMeta(() => getMetaInfo({ page: metaInfo() }));

    const { fetch } = useFetch(async () => {
      try {
        loading.value = true;
        const result = await getArticles({
          params: {
            search_term: (Array.isArray(search) ? search[0] : search) ?? '',
            per_page: PER_PAGE,
            page: currentPage(),
          },
        });
        if (result) {
          const { stories, headers } = result;
          pagination.value.currentPage = currentPage();
          pagination.value.totalPages = getTotalPages(headers);
          articles.value = stories;
          loading.value = false;
        }
      } catch (error) {
        console.log('error', error);
      }
    });
    fetch();

    const goToPage = (page: number) => {
      uiHelpers.changePage(page, false);
      fetch();

      nextTick(() => {
        postsContainerElement.value?.scrollIntoView({ block: 'start' });
        window.scrollBy(0, -200);
      });
    };

    return {
      articles,
      goToPage,
      pagination,
      loading,
      postsContainerElement,
      PER_PAGE,
    };
  },
  head: {},
});
